import breakpoints from '../../scss/base/_breakpoints.module.scss';

const navContainer = jQuery('.primary-navigation');

const resetMenu = () => {
  jQuery('.sub-menu-container.active')
    .fadeOut(250)
    .removeClass('active');
  jQuery('.primary-navigation__nav > li').delay(250).fadeIn(250);
  jQuery('.primary-navigation__nav > li > a').delay(250).fadeIn(250);
};

const isMenuOpen = () => jQuery('body').hasClass('mobile-nav-active');

const closeMenu = () => {
  navContainer.fadeOut(250);
  jQuery('body').removeClass('mobile-nav-active');
  resetMenu();
};

jQuery(($) => {
  $('.nav-opener').on('click', () => {
    if (isMenuOpen()) {
      closeMenu();
    } else {
      $('body').addClass('mobile-nav-active');
      navContainer.fadeIn(250);
    }
  });

  $('.primary-navigation__nav > li.menu-item-has-children > a').on('click', (e) => {
    const isDesktopView = $(window).width() >= parseInt(breakpoints['mobile-nav'], 10);
    if (isDesktopView) {
      return;
    }

    e.preventDefault();
    const thisLi = $(e.currentTarget).closest('li.menu-item-has-children');
    const submenuContainer = thisLi.find('.sub-menu-container');

    submenuContainer.fadeIn(250).addClass('active');

    // Hide sibling `li` elements and the parent `li` itself
    thisLi.siblings('li').fadeOut(250);
    $(e.currentTarget).hide();
  });

  $('.mobile_nav_back').on('click', () => {
    resetMenu();
  });

  $(document).on('click touchstart', (e) => {
    const menu = $('.primary-navigation');
    const opener = $('.nav-opener');

    // eslint-disable-next-line max-len
    const clickTargetOutsideMenu = [menu, opener].every((ele) => !ele.is(e.target) && ele.has(e.target).length === 0);

    if (isMenuOpen() && clickTargetOutsideMenu) {
      closeMenu();
    }
  });

  $(window).on('resize', () => {
    if ($(window).width() > parseInt(breakpoints['mobile-nav'], 10)) {
      if (isMenuOpen()) {
        closeMenu();
      }

      // any submenu containers that were hidden with the above logic
      // due to being closed on mobile should have 'display: none' removed from them
      // eslint-disable-next-line func-names
      $('.sub-menu-container').filter(function () {
        return $(this).attr('style') && $(this).attr('style').includes('display: none');
      }).css('display', '');
    }
  });
});
